// Exports the "tabfocus" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/tabfocus')
//   ES2015:
//     import 'tinymce/plugins/tabfocus'
require('./plugin.js');


// WEBPACK FOOTER //
// ./src/packages/tinymce/plugins/tabfocus/index.js